import Permission from '@admin/app/models/permission.enum'
import { useAdminStore } from '@admin/AppProvider'
import { Stack } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { NoListResult } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useSnackbar } from 'notistack'
import { ContainerDamageTypeCard } from '../components/containerDamageTypeCard/ContainerDamageTypeCard'

export const ContainerDamageTypesContainer = observer(() => {
  const { t } = useTranslate()
  const { containerDamageTypeListUIStore, containerDamageTypeDialogUIStore, authStore } =
    useAdminStore()
  const canEdit = authStore.hasPermission(Permission.WriteDamageCatalogue)

  const { closeSnackbar } = useSnackbar()

  const handleEditClick = (id: number) => {
    closeSnackbar()
    containerDamageTypeDialogUIStore.toggle(id)
  }

  return (
    <Stack gap={2} paddingY={4}>
      {containerDamageTypeListUIStore.containerDamageTypes.map(x => (
        <ContainerDamageTypeCard
          key={x.id}
          containerDamage={x}
          canEdit={canEdit}
          onClick={c => (canEdit ? handleEditClick(c.id) : false)}
        />
      ))}
      {!containerDamageTypeListUIStore.containerDamageTypes.length && (
        <NoListResult
          result={t('noTypeFound', 'No type found')}
          filtering={!!containerDamageTypeListUIStore.searchField}
          onClearFilter={() => containerDamageTypeListUIStore.setSearchField('')}
        />
      )}
    </Stack>
  )
})
